import React, { PureComponent, ReactNode } from 'react';

import bytes from 'bytes';

import FeatureGates from '@atlaskit/feature-gate-js-client';
import { StatsigFeatureKeys } from '@atlassian/bitbucket-features';
import { RelativeDate } from '@atlassian/bitkit-date';

import RenderedTitle from 'src/components/rendered-title';

import { ClientSideLinksCommitMessage } from '../../commit-list/components/commit-list';
import { LastModifiedMetadata } from '../types';

import * as styles from './directory.style';

type DirectoryListRowProps = {
  children?: ReactNode;
  commitLink?: string;
  lastModified?: LastModifiedMetadata | null | undefined;
  size?: number | null;
  hideFileMetadata: boolean;
};

export default class DirectoryListRow extends PureComponent<DirectoryListRowProps> {
  static defaultProps = {
    /* eslint react/default-props-match-prop-types: "warn" */
    hideFileMetadata: false,
  };

  lastModifiedCommitDate(): ReactNode {
    const { commitLink, lastModified } = this.props;

    if (!lastModified) {
      return null;
    }

    return commitLink ? (
      <styles.SubtleLink href={commitLink}>
        <RelativeDate date={lastModified.date} />
      </styles.SubtleLink>
    ) : (
      <RelativeDate date={lastModified.date} />
    );
  }

  render(): ReactNode {
    const { children, size, lastModified, hideFileMetadata } = this.props;
    const enableClientSideLinking = FeatureGates.checkGate(
      StatsigFeatureKeys.enableClientSideLinking
    );

    const lastModifiedMessage = lastModified ? lastModified.message : null;

    return (
      <styles.DirectoryListRow>
        <styles.ItemNameCell>{children}</styles.ItemNameCell>
        {!hideFileMetadata && (
          <styles.ItemSizeCell>
            {size || size === 0 ? bytes(size, { unitSeparator: ' ' }) : null}
          </styles.ItemSizeCell>
        )}
        {!hideFileMetadata && <td>{this.lastModifiedCommitDate()}</td>}
        {!hideFileMetadata && (
          <styles.ItemCommitMessageCell title={lastModifiedMessage || ''}>
            {lastModified &&
            lastModified.rendered &&
            lastModified.rendered.message ? (
              enableClientSideLinking ? (
                <ClientSideLinksCommitMessage
                  renderedContent={lastModified.rendered.message}
                />
              ) : (
                <RenderedTitle
                  fadeLinesAfterFirst
                  renderedContent={lastModified.rendered.message}
                />
              )
            ) : (
              lastModifiedMessage
            )}
          </styles.ItemCommitMessageCell>
        )}
      </styles.DirectoryListRow>
    );
  }
}
